<template>
  <div class="page">
    <ul>
        <li class="u-spec">
            <a href="javascript:;" @click="prevClick()">上一页</a>
        </li>
        <li v-for="index in pages" :class="{active:currentPage == index}" :key="index">
            <a href="javascript:;" @click="btnClick(index)">{{index}}</a>
        </li>
        <li class="u-spec">
            <a href="javascript:;"  @click="nextClick()">下一页</a>
        </li>
    </ul>
  </div>
</template>

<script>
export default {
    name: 'page',
    props: {
        dataNum:{
            type:Number,
            default:100
        },
        current:{
            type:Number,
            default:1
        },
        pageSize:{
            type:Number,
            default:2
        },
        visiblepage: {
            type: Number,
            default: 10
        }
    },
    data:function(){
        return {
            currentPage:0
        }
    },
    created:function(){
        this.currentPage = this.current;
    },
    computed:{
        totalPages:function(){
            return Math.ceil(this.dataNum / this.pageSize) || 0
        },
        pages:function(){
            var lowPage = 1;
            var highPage = this.totalPages;
            var pageArr = [];
            if(this.totalPages > this.visiblepage){
                var sub = Math.ceil(this.visiblepage/2);
                if(this.currentPage > sub && this.currentPage < this.totalPages - sub +1){
                    lowPage = this.currentPage - sub;
                    highPage = this.currentPage + sub - 2;
                }else if(this.currentPage <= sub){
                    lowPage = 1;
                    highPage = this.visiblepage;
                }else{
                    lowPage = this.totalPages - this.visiblepage + 1;
                    highPage = this.totalPages;
                }
            }

            while(lowPage <= highPage){
                pageArr.push(lowPage);
                lowPage ++;
            }
            return pageArr;
        }
    },
    methods:{
        btnClick :function(index){
            this.currentPage = index;
            //this.$emit('change-page',index);
        },
        prevClick:function(){
            if (this.currentPage > 1) {
                this.currentPage--;
                //this.$emit('change-page', this.currentPage)
            }
            
        },
        nextClick:function(){
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
                //this.$emit('change-page', this.currentPage)
            }
        }
    },
    watch:{
		currentPage:function(curval){
            //console.log(curval);
            this.$emit('change-page', curval)
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.page{ 
    display: inline-block;
	height: 40px;
}
ul {
  list-style-type: none;
  padding: 0;
 
}
li {
    float: left;;
    margin: 0 16px 0 0;
    font-size: 20px;
    height: 40px;
    line-height: 40px;
    a{
        color: #818181;
        display: inline-block;
        width: 38px;
        height: 38px;
        line-height: 38px;
        border: 1px solid #e1e1e1;
    }
}
.active{
    a{
        border-color: #4A90E2;
    }
}
.u-spec{
    a{
        width: 60px;
        border:none;
    }
    
}

</style>
